import {
  ADD_PRESCRIBER,
  ADD_PRESCRIBER_FAIL,
  ADD_PRESCRIBER_SUCCESS,
  DELETE_PRESCRIBER,
  DELETE_PRESCRIBER_FAIL,
  DELETE_PRESCRIBER_SUCCESS,
  GET_PRESCRIBERS_LIST,
  GET_PRESCRIBERS_LIST_FAIL,
  GET_PRESCRIBERS_LIST_SUCCESS,
  GET_TASK_PRESCRIBERS_LIST,
  GET_TASK_PRESCRIBERS_LIST_FAIL,
  GET_TASK_PRESCRIBERS_LIST_SUCCESS,
  UPDATE_PRESCRIBER,
  UPDATE_PRESCRIBER_FAIL,
  UPDATE_PRESCRIBER_SUCCESS,
} from "./actionType";

export const getPrescribers = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_PRESCRIBERS_LIST,
  payload: { data, onSuccess, onError },
});

export const getPrescribersSuccess = data => ({
  type: GET_PRESCRIBERS_LIST_SUCCESS,
  payload: data,
});

export const getPrescribersFail = data => ({
  type: GET_PRESCRIBERS_LIST_FAIL,
  payload: data,
});

export const updatePrescriber = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_PRESCRIBER,
  payload: { data, onSuccess, onError },
});

export const updatePrescriberSuccess = data => ({
  type: UPDATE_PRESCRIBER_SUCCESS,
  payload: data,
});

export const updatePrescriberFail = data => ({
  type: UPDATE_PRESCRIBER_FAIL,
  payload: data,
});

export const addPrescriber = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_PRESCRIBER,
  payload: { data, onSuccess, onError },
});

export const addPrescriberSuccess = data => ({
  type: ADD_PRESCRIBER_SUCCESS,
  payload: data,
});

export const addPrescriberFail = data => ({
  type: ADD_PRESCRIBER_FAIL,
  payload: data,
});

export const deletePrescriber = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: DELETE_PRESCRIBER,
  payload: { data, onSuccess, onError },
});

export const deletePrescriberSuccess = data => ({
  type: DELETE_PRESCRIBER_SUCCESS,
  payload: data,
});

export const deletePrescriberFail = data => ({
  type: DELETE_PRESCRIBER_FAIL,
  payload: data,
});

export const getTaskPrescribers = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_TASK_PRESCRIBERS_LIST,
  payload: { data, onSuccess, onError },
});

export const getTaskPrescribersSuccess = data => ({
  type: GET_TASK_PRESCRIBERS_LIST_SUCCESS,
  payload: data,
});

export const getTaskPrescribersFail = data => ({
  type: GET_TASK_PRESCRIBERS_LIST_FAIL,
  payload: data,
});
